import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { BaseTransformer } from './BaseTransformer';
export var TimezoneTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(TimezoneTransformer, _BaseTransformer);
  var _super = _createSuper(TimezoneTransformer);
  function TimezoneTransformer() {
    _classCallCheck(this, TimezoneTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(TimezoneTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      return {
        value: data.id,
        label: data.label
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      return {};
    }
  }]);
  return TimezoneTransformer;
}(BaseTransformer);